import type { AuthAction, AuthState } from './types'

export const RESEND_COOLDOWN_MS = 30_000

export const initialAuthState: AuthState = { phase: 'anonymous' }

export const authReducer = (
  state: AuthState,
  action: AuthAction
): AuthState => {
  switch (action.type) {
    case 'code_sent':
      return {
        phase: 'awaiting-code',
        email: action.email,
        resendAvailableAt: action.resendAvailableAt,
        attemptCount: 0,
        lastError: null,
      }

    case 'verify_failed':
      if (state.phase !== 'awaiting-code') return state
      return {
        ...state,
        attemptCount: state.attemptCount + 1,
        lastError: action.reason,
      }

    case 'verify_succeeded':
    case 'logged_in':
      return { phase: 'authenticated' }

    case 'logged_out':
      return action.reason
        ? { phase: 'anonymous', reason: action.reason }
        : { phase: 'anonymous' }
  }
}
